module.exports = __webpack_public_path__ + "img/chat-bot.c8d69299.svg";